'use strict';

var React = require('react');
var IconBar = React.createClass({
  render : function(){
    return (
      <div className="component component-iconbar contents-layout"
           style={{
            overflow : 'hidden'
           }}>
      {
        this.props.children
      }
    </div>);
  }
});

module.exports = IconBar;


// WEBPACK FOOTER //
// ./src/views/Components/IconBar.jsx